import { Action } from "redux";

export const SET_SIDEBAR_COLLAPSE = "SET_SIDEBAR_COLLAPSE";
export interface SetSidebarCollapse extends Action {
  type: typeof SET_SIDEBAR_COLLAPSE;
  isSidebarCollapsed: boolean;
}

export type LayoutActions = SetSidebarCollapse;
